<template>
  <v-container>
    <v-layout column style="padding: 10px; border: 1px dotted #dfdfdf;">
      <h3>Darstellung Verbindungslinen</h3><br>
      <p>Bitte wähle Sie die Darstellungsform innerhalb der Kartenansicht</p>
      <v-layout row>
        <v-flex justify-space-around>
          <span v-if="showLines === true">
            <v-chip
              label
              color="green"
              text-color="white"
            >
              <v-avatar>
                <v-icon>check_circle</v-icon>
              </v-avatar>
              Ausgewählt
            </v-chip>
          </span>
          <span v-if="showLines === false">
            <v-chip
              label
              color="grey"
              text-color="white"
            >
              <v-avatar>
                <v-icon>check_circle</v-icon>
              </v-avatar>
              Ausgewählt
            </v-chip>
          </span>
          <div @click="setLines(true)">
            <v-img
              class="options"
              max-width="250px"
              src="/images/setting_with_lines.png"
            />
          </div>
        </v-flex>
        <v-flex>
          <span v-if="showLines === false">
            <v-chip
              label
              color="green"
              text-color="white"
            >
              <v-avatar>
                <v-icon>check_circle</v-icon>
              </v-avatar>
              Ausgewählt
            </v-chip>
          </span>
          <span v-if="showLines === true">
            <v-chip
              label
              color="grey"
              text-color="white"
            >
              <v-avatar>
                <v-icon>check_circle</v-icon>
              </v-avatar>
              Ausgewählt
            </v-chip>
          </span>


          <div @click="setLines(false)">
            <v-img
              class="options"
              max-width="250px"
              src="/images/setting_no_lines.png"
            />
          </div>
        </v-flex>
      </v-layout>
    </v-layout>
    <v-divider />
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'Settings',
  computed: {
    ...mapGetters(['showLines']),
  },
  methods: {
    ...mapActions(['setLines']),
  },
};
</script>

<style scoped>
 .options:hover {
    -webkit-box-shadow: 1px -1px 24px 9px rgba(0,0,0,0.32);
    -moz-box-shadow: 1px -1px 24px 9px rgba(0,0,0,0.32);
    box-shadow: 1px -1px 24px 9px rgba(0,0,0,0.32);
  }
  .active {
    background-color: #000;
  }

</style>
